<div class="modal-header">
  <h1 id="modal-title" class="modal-title">Upload Item</h1>
  <button class="close" aria-label="Close" ngbAutofocus (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [class.d-none]="saving">
    @if (!editing && uploadingComplete && fileResponse) {
      <div>
        @if (fileResponse.status == "success") {
          <div>
            <!-- This is where we display the asset details and let them edit the description and link them to the detail view. -->
            <p class="text-center">
              {{ "sphere.upload.complete" | translate }}
              <br />
              <small class="c-dark-gray">{{ "sphere.update_exchange" | translate }}</small>
            </p>
            <div class="form-group">
              <label class="control-label" for="title">{{ "profile.edit.title" | translate }}</label>
              <input type="text" name="title" id="title" [value]="fileResponse.ware.title" [(ngModel)]="newAsset.title" class="form-control" />
            </div>
            <div class="form-group">
              <label class="control-label" for="description">{{ "profile.edit.description" | translate }}</label>
              <textarea name="description" id="description" [(ngModel)]="newAsset.description" class="form-control">{{ fileResponse.ware.description }}</textarea>
            </div>
            @if (extraData[fileResponse.ware.category]) {
              <div>
                <div class="form-group">
                  <label class="control-label" for="title">{{ extraData[fileResponse.ware.category] == "Device" ? "Device" : "Category" }}</label>
                  <!-- <input type="text" name="extraData[fileResponse.ware.category] == 'Device' ? 'device' : 'category'" id="extraData[fileResponse.ware.category] == 'Device' ? 'device' : 'category'" [value]="" [(ngModel)]="extraData[fileResponse.ware.category] == 'Device' ? newAsset.device : newAsset.category" class="form-control" > -->
                  @if (extraData[fileResponse.ware.category] == "Device") {
                    <input type="text" name="device'" id="device" [(ngModel)]="newAsset.device" class="form-control" />
                  }
                  @if (extraData[fileResponse.ware.category] == "CategoryAttribute") {
                    <input type="text" name="categoryattribute'" id="categoryattribute" [(ngModel)]="newAsset.categoryattribute" class="form-control" />
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (fileResponse.error) {
          <div>{{ "sphere.error" | translate }}: {{ fileResponse.error }}</div>
        }
      </div>
    }

    @if (editing) {
      <div>
        <div class="form-group">
          <label class="control-label" for="title">{{ "profile.edit.title" | translate }}</label>
          <input type="text" name="title" id="title" [value]="editing.title" [(ngModel)]="editing.title" class="form-control" />
        </div>
        <div class="form-group">
          <label class="control-label" for="description">{{ "profile.edit.description" | translate }}</label>
          <textarea name="description" id="description" [(ngModel)]="editing.description" class="form-control">{{ editing.description }}</textarea>
        </div>
        @if (extraData[editing.extension]) {
          <div>
            <div class="form-group">
              <label class="control-label" for="title">{{ extraData[editing.extension] == "Device" ? "Device" : "Category" }}</label>
              @if (extraData[editing.extension] == "Device") {
                <input type="text" name="device'" id="device" [(ngModel)]="editing.device" class="form-control" />
              }
              @if (extraData[editing.extension] == "CategoryAttribute") {
                <input type="text" name="categoryattribute'" id="categoryattribute" [(ngModel)]="editing.category" class="form-control" />
              }
            </div>
          </div>
        }
        @if (editing.category == "pitchlist") {
          <div>
            <div class="form-group">
              <label class="control-label" for="title">{{ "sphere.device" | translate }}</label>
              <input type="text" name="device" id="device" [value]="" [(ngModel)]="editing.device" class="form-control" />
            </div>
          </div>
        }
      </div>
    }

    @if (editing || (uploadingComplete && fileResponse)) {
      <div class="form-group">
        <label class="control-label" for="audio_preview">{{ "sphere.audio_previews" | translate }}</label>
        &nbsp;
        <div class="audio-previews">
          @for (preview of audioPreviews; track preview) {
            <div class="preview">
              {{ preview.fileName }}
            </div>
          }
        </div>
        <small>{{ "sphere.to_add_audio_preview" | translate }}</small>
        @if (previewUploader && previewUploader.queue.length && previewUploader.isUploading && !previewFileResponse) {
          <div>
            @for (item of previewUploader.queue; track item) {
              <div class="text-center" style="position: relative">
                <span style="color: gray; font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">{{ "general.uploading" | translate }} {{ item?.file?.name }}</span>
                <br />
                <br />
                <div style="display: inline-block; margin: auto">
                  <round-progress
                    [current]="item.progress"
                    [max]="100"
                    [color]="'#45ccce'"
                    [background]="'#eaeaea'"
                    [radius]="125"
                    [stroke]="20"
                    [semicircle]="false"
                    [rounded]="true"
                    [clockwise]="true"
                    [responsive]="false"
                    [duration]="250"
                    [animation]="'easeInOutQuart'"
                    [animationDelay]="0"
                  ></round-progress>
                </div>
                <br />
                @if (!previewUploadingComplete) {
                  <span class="uploading-label">{{ item?.progress }}%</span>
                }
                @if (previewUploadingComplete && !previewFileResponse) {
                  <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
                }
              </div>
            }
          </div>
        }
        @if (previewUploader && !uploadingPreviewFile) {
          <div ng2FileDrop class="drop-zone" [class.hovering]="hasBaseDropZoneOverPreview" (fileOver)="fileOverBase($event, 'preview')" [uploader]="previewUploader">
            {{ hasBaseDropZoneOverPreview ? "Drop It! " : "Drop an audio preview file here..." }}
            <br />
            <span class="text-sm">Accepted file formats: .wav, .mp3</span>
            <br />
            <br />
            <div class="text-center">
              or
              <input aria-label="drop file" type="file" ng2FileSelect [uploader]="previewUploader" />
            </div>
          </div>
        }
      </div>
    }

    @if (!uploader.queue.length && !uploadingComplete) {
      <div>
        <small id="upload-your-item">Upload your item below.</small>
        <div ng2FileDrop class="drop-zone" [class.hovering]="hasBaseDropZoneOver" (fileOver)="fileOverBase($event)" [uploader]="uploader">
          {{ hasBaseDropZoneOver ? ("profile.edit.dropit" | translate) : editing ? ("sphere.upload.drop_file_replace_item" | translate) : ("profile.edit.drophere" | translate) }}
          <br />
          <span class="text-sm">
            {{ "profile.edit.accepted_formats" | translate }}:
            @for (ext of allowedExtensions; track ext; let i = $index) {
              <span>{{ "." + ext + (i == allowedExtensions.length - 1 ? "" : ", ") }}</span>
            }
          </span>
          <br />
          <br />
          <div class="text-center">
            or
            <input id="upload-input" [attr.aria-label]="'Choose file. ' + fileName" type="file" ng2FileSelect [uploader]="uploader" />
          </div>
        </div>
      </div>
    }

    @if (uploader.queue.length && !uploader.isUploading && !fileResponse) {
      <div>
        <div class="text-center">
          <h2 class="subsection-header">{{ "sphere.upload.queued" | translate }}:</h2>
          @for (item of uploader.queue; track item) {
            <div class="text-center" style="position: relative">
              <span class="c-dark-gray" style="font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">{{ item?.file?.name }}</span>
            </div>
          }
          <button type="button" class="btn btn-primary m-t-20" (click)="performUpload()">{{ "sphere.upload.upload_now" | translate }}</button>
        </div>
      </div>
    }

    @if (uploader.queue.length && uploader.isUploading && !fileResponse) {
      <div>
        @for (item of uploader.queue; track item) {
          <div class="text-center" style="position: relative">
            <span style="color: gray; font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">{{ "general.uploading" | translate }} {{ item?.file?.name }}</span>
            <br />
            <br />
            <div style="display: inline-block; margin: auto">
              <round-progress
                [current]="item.progress"
                [max]="100"
                [color]="'#45ccce'"
                [background]="'#eaeaea'"
                [radius]="125"
                [stroke]="20"
                [semicircle]="false"
                [rounded]="true"
                [clockwise]="true"
                [responsive]="false"
                [duration]="250"
                [animation]="'easeInOutQuart'"
                [animationDelay]="0"
              ></round-progress>
            </div>
            <br />
            @if (!uploadingComplete) {
              <span class="uploading-label">{{ item?.progress }}%</span>
            }
            @if (uploadingComplete && !fileResponse) {
              <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
            }
          </div>
        }
      </div>
    }

    @if (editing && uploadingComplete && fileResponse) {
      <div>
        @if (fileResponse.status == "success") {
          <div class="text-center">
            {{ "sphere.upload.complete_updated" | translate }}
          </div>
        }
        @if (fileResponse.error) {
          <div>{{ "sphere.error" | translate }}: {{ fileResponse.error }}</div>
        }
      </div>
    }
  </div>

  <myp-inline-loader [loading]="saving" height="200px" spinnerName="uploadWareLoader"></myp-inline-loader>
</div>
<div class="modal-footer">
  @if (!editing && uploadingComplete && fileResponse) {
    <button type="button" class="btn btn-primary" (click)="saveNewAssetDetails()">{{ "general.save" | translate }}</button>
  }
  <!-- <button type="button" *ngIf="!editing && newAsset && uploadingComplete && fileResponse" class="btn btn-primary" (click)="viewNewAsset()">View Extension</button> -->
  @if (editing) {
    <button type="button" class="btn btn-primary" (click)="saveAssetDetails()">{{ "general.save" | translate }}</button>
  }
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
